import "./Characteristics.css"
import GreeceMap from "../components/Map"
import { useState } from "react";
import SelectInformation from "../components/CharacteristicsComponents/SelectInformation";
import FetchMultiSelector from "../components/CharacteristicsComponents/FetchMultiSelector";

export default function Characteristics(){

    //Save value of MultiSelector
    const [AirportSelection,setAirportSelection] = useState([])

    return(
        <div className="container page-wrapper">
            <h1>Χαρακτηριστικά</h1>
            {/* <p>Επιλέξτε επάνω στο χάρτη ή από τη λίστα το αεροδρόμιο που σε ενδιαφέρει.</p> */}
            <GreeceMap></GreeceMap>
            <FetchMultiSelector passData = {setAirportSelection}></FetchMultiSelector>
            {AirportSelection.length !== 0? <SelectInformation AirportSelection = {AirportSelection} ></SelectInformation>: <div style = {{marginLeft: "25%", marginTop: "10%"}}><p><strong>Δεν εντοπίστηκαν ακόμη πληροφορίες</strong></p> <p>Επιλέξτε από <strong>την λίστα </strong> που διαθέτουμε το αεροδρόμιο που επιθυμείς.</p></div>}
        </div>
    )
}
